function ArmyModal({myNormalDistributorData, oppNormalDistributorData}) {
    // console.log('myNormalDistributorData ==army', myNormalDistributorData);
    // console.log('oppNormalDistributorData', oppNormalDistributorData);
    return (
        <>

            <div className="modal fade" id="my-army-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabelArmy"
                aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content armymodal">
                        <div className="army-name-box text-center">
                            <p>Normal Distributor</p>
                        </div>
                        <div className="astrabox">
                            <p>Astra:</p>
                            <div className="imgncmpbox">
                            {
                                            myNormalDistributorData.astra > 0 &&
                                            Array.from({ length: myNormalDistributorData.astra }).map((_, index) => (
                                                <img
                                                    key={index}
                                                    src="../images/BOR/brahmastra-stone1.png"
                                                    className="img-fluid astraimgstone"
                                                    alt="Astra"
                                                />
                                            ))
                                        }
                            <span className="ptscmplte">{myNormalDistributorData.astra} Complete</span>
                            </div>
                        </div>
                        <div className="ptsbox">
                            <p>Points:</p>
                            <span className="ptscmplte">{Math.round(myNormalDistributorData.points)}</span>
                        </div>
                        <div className="armyimgbox p-3 mt-5">
                            <img src="../images/BOR/Normal-distributor-army-back-view.png" className="img-fluid armyimg"></img>
                        </div>
                        <div className="footerclose-contaner">
                            <button type="button" className="close mb-3" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src="../images/BOR/close-button.png" className="img-fluid w-50" /></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="opp-army-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabelArmy"
                aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content armymodal">
                        <div className="army-name-box text-center">
                            <p>Normal Distributor</p>
                        </div>
                        <div className="astrabox">
                            <p>Astra:</p>
                            {
                                            oppNormalDistributorData.astra > 0 &&
                                            Array.from({ length: oppNormalDistributorData.astra }).map((_, index) => (
                                                <img
                                                    key={index}
                                                    src="../images/BOR/brahmastra-stone1.png"
                                                    className="img-fluid astraimgstone"
                                                    alt="Astra"
                                                />
                                            ))
                                        }
                            <span className="ptscmplte">{oppNormalDistributorData.astra} Complete</span>
                            
                        </div>
                        <div className="ptsbox">
                            <p>Points:</p>
                            <span className="ptscmplte">{Math.round(oppNormalDistributorData.points)}</span>
                        </div>
                        <div className="armyimgbox p-3 mt-5">
                            <img src="../images/BOR/Normal-distributor-army-front-view.png" className="img-fluid armyimg"></img>
                        </div>
                        <div className="footerclose-contaner">
                            <button type="button" className="close mb-3" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><img src="../images/BOR/close-button.png" className="img-fluid w-50" /></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ArmyModal;